module.exports = __webpack_public_path__ + "assets/tick-new.679b965e5c5675c64b710d57786305af.svg";